<template>
  <virtual-assistant-lib
    :download-service="downloadService"
    :get-citation-file-service="getCitationFileService"
    :send-chat-service="sendChatService"
    :user-full-name="userFullName"
  />
</template>

<script>
// libs
import VirtualAssistantLib from '@quisit/virtual-assistant';

// services
import {
  sendChat,
  getCitationFile,
} from '@/modules/helpdesk/virtualAssistant.js';
import documentService from '@/modules/shared/documents.api.js';

export default {
  name: 'VirtualAssistant',
  components: {
    VirtualAssistantLib,
  },
  props: {
    userFullName: {
      type: String,
      default: '',
    },
  },
  methods: {
    sendChatService(payload) {
      return sendChat(payload);
    },
    getCitationFileService(payload) {
      return getCitationFile(payload);
    },
    downloadService(payload) {
      return documentService.Download(payload);
    },
  },
};
</script>
